import { LoadingButton } from "@mui/lab";
import { TextField } from "@mui/material";
import { t } from "i18next";
import React, { useContext, useState } from "react";
import { client } from "../../..";
import { upsertQBP } from "../../../api/api";
import { EnterLayout } from "../../../components/EnterLayout";
import { isNullOrUndefined, showErrorMessage } from "../../../helper/helper";
import { BidModel } from "../../../models/bid/BidModel";
import { OrgBidModel } from "../../../models/bid/OrgBidModel";
import { QualityLevel } from "../../../models/organisation/Organisation";
import { colorLight, colorPrimary, colorPrimaryDark } from "../../../rsc/colors/colors";
import { PopupEditPrice } from "./PopupEditPrice";
import { PriceReloadContext } from "./PriceContainer";

type Props = {
    quality: QualityLevel
    bid: BidModel
    org: OrgBidModel
}

export function QBPPriceRow({ quality, bid, org }: Props) {

    const [loading, setLoading] = useState(false)

    const [displayPopup, setDisplayPopup] = useState(false)

    const [newPrice, setNewPrice] = useState(quality.price_per_kg)
    const [priceInput, setPriceInput] = useState<string>(quality.price_per_kg?.toString())

    const { reload } = useContext(PriceReloadContext)

    function isPriceSet(): boolean {
        return newPrice !== undefined && newPrice !== null
    }

    function getStyleForButton(): React.CSSProperties {
        if (loading) {
            return {
                backgroundColor: "grey",
                color: "grey"
            }
        } else {
            return {
                backgroundColor: isPriceSet() ? colorPrimaryDark() : colorPrimary(),
                color: colorLight()
            }
        }
    }

    function onInputChange(value: string) {
        const re = /^[0-9]+$/

        if (value.length === 0) {
            setPriceInput('')
        } else if (re.test(value)) {
            setPriceInput(value)
        }
    }

    function getPriceLayout() {
        if (!isPriceSet()) {
            return (<div style={{ display: "flex", alignItems: "center", flex: 1, justifyContent: "end" }}>
                <p className='greyColor font-14' style={{ display: "inline-block", margin: "0 5px 0 0", fontWeight: "500" }}>Rp/Kg</p>
                <TextField
                    variant="standard"
                    // disabled={!props.isEditable(props.org, props.price)}
                    value={priceInput}
                    // error={onPriceError}
                    type='numeric'
                    inputProps={{ className: 'font-24', maxLength: 4, style: { textAlign: 'end', fontWeight: "700", width: "60px", maxWidth: "5ch" } }}
                    onChange={(e) => onInputChange(e.target.value)}
                />
            </div>)
        } else {
            return <div style={{ display: "flex", alignItems: "center", flex: 1, justifyContent: 'end' }}>
                <p className='font-14' style={{ display: "inline-block", margin: "0" }}>Rp/Kg</p>
                <p className='font-24' style={{ display: "inline-block", margin: "0 0 0 5px", textAlign: 'end', fontWeight: "700" }}>{newPrice}</p>
            </div>
        }
    }

    function onSave(price: string) {
        if (!bid.price_per_quantity_unit) {
            showErrorMessage(t('need_bid_for_qbp'))
        } else if (price.length === 0) {
            showErrorMessage(t('need_valid_number'))
        } else {
            const p = parseInt(price)
            setLoading(true)
            client.mutate({
                mutation: upsertQBP,
                variables: {
                    input: {
                        cardinality: quality.cardinality,
                        delta: price ? parseInt(price) : null,
                        market_id: bid.market_day,
                        organisation_id: org.organisationId
                    }
                },
                context: {
                    headers: {
                        "role": "usermill"
                    }
                }
            }).then((data) => {
                setNewPrice(p)
                reload()
                onCancel()
            }, (e: TypeError) => {
                showErrorMessage(e)
            }).finally(() => setLoading(false)
            )
        }
    }

    function onCancel() {
        setDisplayPopup(false)
    }

    return (
        <EnterLayout onClick={() => {
            if (isPriceSet()) {
                setDisplayPopup(true)
            } else {
                onSave(priceInput)
            }
        }}>
            <div style={{ display: "flex", alignItems: "center", paddingLeft: "10px", gap: '10px', marginBottom: '10px' }}>
                <div style={{ flex: 1 }}>
                    {quality.name}
                </div>
                {getPriceLayout()}
                <div style={{ flex: 1, display: "flex", justifyContent: "end" }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', fontWeight: '600' }}>
                        <p className='greyColor font-14' style={{ display: "inline-block", fontWeight: "500" }}>Rp/Kg</p>
                        <p className="font-24" style={{ color: colorPrimaryDark() }}>{ !isNullOrUndefined(newPrice) ? (newPrice ?? 0) + (bid?.price_per_quantity_unit ?? 0) : "-"}</p>
                    </div>
                </div>
                {
                    isPriceSet() ?
                        <LoadingButton
                            style={{ width: "100px", ...getStyleForButton() }}
                            variant="contained"
                            loading={loading}
                            onClick={() => {
                                setDisplayPopup(true)
                            }}>
                            {t('edit')}
                        </LoadingButton>
                        : <LoadingButton
                            style={{ width: "100px", ...getStyleForButton() }}
                            variant="contained"
                            loading={loading}
                            onClick={() => onSave(priceInput)}
                        >
                            {t('save')}
                        </LoadingButton>
                }
            </div>
            <PopupEditPrice price={newPrice}
                open={displayPopup}
                // onDelete={(np) => onSave(null)}
                onSave={(np) => onSave(np)}
                onCancel={onCancel} />
        </EnterLayout>
    )
}